export const AUTH_CHECK = {
  REQUEST: "AUTH_CHECK",
  PENDING: "AUTH_CHECK_PENDING",
  REJECTED: "AUTH_CHECK_REJECTED",
  FULFILLED: "AUTH_CHECK_FULFILLED"
}

export const LOG_OUT = "LOG_OUT"